import React from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { RxReset } from 'react-icons/rx';

export const BoardToolboxZoomControls = ({
  zoom = 1,
  onZoomOut,
  onZoomReset,
  onZoomIn,
  baseBtnClass = '',
}) => (
  <div className='flex items-center rounded border border-contrast border-opacity-20 px-03'>
    <button
      type='button'
      className={`${baseBtnClass} text-contrast`}
      onClick={onZoomOut}
      title='Zoom -'
      aria-label='Zoom Out'
    >
      <FaMinus size={10} />
    </button>
    <button
      type='button'
      className={`${baseBtnClass} min-w-14 text-xs text-contrast`}
      onClick={onZoomReset}
      title='Revenir à 100%'
      aria-label='Zoom Reset'
    >
      <RxReset size={12} />
      <span className='text-xs ml-05'>{Math.round(zoom * 100)}%</span>
    </button>
    <button
      type='button'
      className={`${baseBtnClass} text-contrast`}
      onClick={onZoomIn}
      title='Zoom +'
      aria-label='Zoom In'
    >
      <FaPlus size={10} />
    </button>
  </div>
);
